import service from '@/store/services/workshop/dashboard-service';

const state = {
  list: {},
  dashboard: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, dashboard) => {
    state.dashboard = dashboard;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};
 
const actions = {

  fakturNotaJasa({commit, dispatch}, params) {
    return service.fakturNotaJasa(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  fakturNotaPart({commit, dispatch}, params) {
    return service.fakturNotaPart(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  procurementOrder({commit, dispatch}, params) {
    return service.procurementOrder(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },



  repairStatus({commit, dispatch}, params) {
    return service.repairStatus(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  traceHold({commit, dispatch}, params) {
    return service.traceHold(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },


  // destroy({commit, dispatch}, params) {
  //   return service.destroy(params);
  // }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total, 
  dashboard: state => state.dashboard,
};
 
const dashboard = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default dashboard;
